import { selectProfileByIdQueryOptions } from "@/features/profile/api/selectProfile";
import { OnboardingPatientPage } from "@/features/onboarding/components/OnboardingPatientPage";
import { useNavigateToPrevOnboardingRoute } from "@/features/onboarding/hooks/useNavigateToPrevOnboardingRoute";
import PreferencesForm from "../../features/knock/components/PreferencesForm";
import type { ProfileT } from "@patient-watch/types/database";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

const Notifications = () => {
    const navigate = useNavigate();
    const nextPage = () => navigate({ to: "/onboarding/complete" });
    const backPage = useNavigateToPrevOnboardingRoute("/onboarding/notifications");

    return (
        <OnboardingPatientPage step="notifications">
            <PreferencesForm onSuccess={nextPage} onBack={backPage} isDialog={false} />
        </OnboardingPatientPage>
    );
};
export const Route = createFileRoute("/onboarding/notifications")({
    component: Notifications,
    loader: async ({ context }) => {
        let profile: ProfileT | null = null;
        if (context?.auth?.id) {
            profile = await context?.queryClient.ensureQueryData(selectProfileByIdQueryOptions(context.auth.id));
        }
        return { profile };
    },
});
